module.exports = new Promise(async (resolve, reject) => {
  try {
    const module = await import('https://sn2-care-journal-lsh-prod.web.app/assets/remoteEntry.js?t=1792677140157');
    resolve(module);
  } catch (error) {
    // console.error('Failed to load remote:', error);
    resolve(null);
  }
})
;